import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('#modalPopup').modal('show');
  }
}